import $ from "jquery";

export const init = () => {

    $("#mainmenu-open").click(function (e) {
        e.preventDefault();
        $('body').addClass("menu-open");
    });

    $("#mainmenu-close").click(function (e) {
        e.preventDefault();
        $('body').removeClass("menu-open");
    });

    $(window).on('load resize', function () {
        var windowWidth = window.innerWidth;
        if (windowWidth >= 992) {
            $('body').removeClass("menu-open");
        }
    });

    /*---------sticky header---------*/
    function updateStickyHeader() {
        if (window.scrollY >= 50) {
            document.body.classList.add('sticky-header');
        } else {
            document.body.classList.remove('sticky-header');
        }
        if (window.innerWidth < 992) {
            document.body.classList.add('sticky-header');
        }
    }
    $(window).on('resize scroll', updateStickyHeader);
    updateStickyHeader();
    /*---------/sticky header ---------*/

};

